var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center border-red"},[_c('v-btn',{staticClass:"mt-4",attrs:{"rounded":"","color":"accent "},on:{"click":_vm.openDialog}},[_vm._v(_vm._s(_vm.$t('welcome.button.show_message')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }